import auth0 from '../auth0'
import { newRelicTriggerErrorEvent, newRelicTimeFunction } from '../newrelic'

export default async function getSessionPasswordless(
  basketId: string,
  checkout: string | null,
): Promise<void> {
  try {
    const queryParameter = `?basket_id=${encodeURIComponent(basketId)}`
    const accessToken = await newRelicTimeFunction('getTokenSilently', () =>
      auth0().getTokenSilently({ cacheMode: 'off' }),
    )
    const apiEndpoint =
      checkout === 'true'
        ? '/customer-identity/single-sign-on/session/passwordless/checkout'
        : '/customer-identity/single-sign-on/session/passwordless'
    const url = `${apiEndpoint}${queryParameter}`
    const res = await fetch(url, {
      method: 'POST',
      credentials: 'include',
      headers: {
        Authorization: `Bearer ${accessToken}`,
        Accept: 'application/json',
        'Content-Type': 'application/json',
      },
    })
    if (!res.ok) {
      const json = await res.json()
      throw json
    }
  } catch (error) {
    newRelicTriggerErrorEvent('browse-passwordless', error)
  }
}
